var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05447 3.46289L0.633734 10.8836C0.531526 10.9858 0.467351 11.1205 0.451504 11.2639L0.00385813 15.296C-0.0159494 15.4751 0.0410957 15.6541 0.161526 15.7888C0.281956 15.9227 0.453094 15.9996 0.633734 15.9996C0.656711 15.9996 0.68048 15.998 0.703457 15.9956L4.73795 15.5472V15.548C4.88215 15.5321 5.01605 15.4679 5.11825 15.3657L12.5366 7.94499L8.05447 3.46289Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4425 2.34977L13.6496 0.556799C12.9072 -0.1856 11.7037 -0.1856 10.9604 0.556799L8.95117 2.56688L13.4333 7.04983L15.4442 5.03896H15.4434C16.1858 4.29577 16.1849 3.09219 15.4425 2.34977Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.80ace56aa4b3a7c91f2ddacd8a93bdff.svg";
export { ForwardRef as ReactComponent };